import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";
import {AbstractControl, FormControl, Validators} from "@angular/forms";

@Component({
	templateUrl: './set_divly_id.component.html'
})
export class SetDivlyIdModalComponent extends BaseSupportModalComponent {
	userId: string;
	divlyId: string;

	ngOnInit() {
		this.spreader.base.form = this.form;
		
		this.form.addControl('divlyId', new FormControl('',[
			this.getCustomValidator('divlyId_required', function(name: string, control: AbstractControl) {
				const isInvalid = Validators.required(control);

				let err = {};
				err[name] = {value: control.value, message: '"Divly partner Id" - обязательное поле'};

				return isInvalid != null ? err : null;
			}),
		]));
	}

	async ok() {
		if (confirm(`Вы уверены, что хотите назначить Divly Id аккаунту: ${this.title}?`)) {
			
			await this.supportService.setDivlyId(this.userId, this.divlyId, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
